/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentAvailability } from './AppointmentAvailability';
import {
    AppointmentAvailabilityFromJSON,
    AppointmentAvailabilityFromJSONTyped,
    AppointmentAvailabilityToJSON,
    AppointmentAvailabilityToJSONTyped,
} from './AppointmentAvailability';
import type { PurposeType } from './PurposeType';
import {
    PurposeTypeFromJSON,
    PurposeTypeFromJSONTyped,
    PurposeTypeToJSON,
    PurposeTypeToJSONTyped,
} from './PurposeType';
import type { AttendanceType } from './AttendanceType';
import {
    AttendanceTypeFromJSON,
    AttendanceTypeFromJSONTyped,
    AttendanceTypeToJSON,
    AttendanceTypeToJSONTyped,
} from './AttendanceType';

/**
 * 
 * @export
 * @interface AppointmentResponse
 */
export interface AppointmentResponse {
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    appointmentId: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    purposeKey: string;
    /**
     * 
     * @type {PurposeType}
     * @memberof AppointmentResponse
     */
    purposeType: PurposeType;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentResponse
     */
    startTimeUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentResponse
     */
    endTimeUtc: Date;
    /**
     * 
     * @type {AppointmentAvailability}
     * @memberof AppointmentResponse
     */
    availability: AppointmentAvailability;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentResponse
     */
    createdAtUtc: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentResponse
     */
    isAllDay: boolean;
    /**
     * 
     * @type {AttendanceType}
     * @memberof AppointmentResponse
     */
    attendanceType?: AttendanceType | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    clientFirstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    clientLastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    assignedCounselorUserCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    details?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    substituteCounselorId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    substituteCounselorUserCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    clientPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentResponse
     */
    clientEmail?: string | null;
}



/**
 * Check if a given object implements the AppointmentResponse interface.
 */
export function instanceOfAppointmentResponse(value: object): value is AppointmentResponse {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('purposeType' in value) || value['purposeType'] === undefined) return false;
    if (!('startTimeUtc' in value) || value['startTimeUtc'] === undefined) return false;
    if (!('endTimeUtc' in value) || value['endTimeUtc'] === undefined) return false;
    if (!('availability' in value) || value['availability'] === undefined) return false;
    if (!('createdAtUtc' in value) || value['createdAtUtc'] === undefined) return false;
    if (!('isAllDay' in value) || value['isAllDay'] === undefined) return false;
    return true;
}

export function AppointmentResponseFromJSON(json: any): AppointmentResponse {
    return AppointmentResponseFromJSONTyped(json, false);
}

export function AppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': json['appointmentId'],
        'purposeKey': json['purposeKey'],
        'purposeType': PurposeTypeFromJSON(json['purposeType']),
        'startTimeUtc': (new Date(json['startTimeUtc'])),
        'endTimeUtc': (new Date(json['endTimeUtc'])),
        'availability': AppointmentAvailabilityFromJSON(json['availability']),
        'createdAtUtc': (new Date(json['createdAtUtc'])),
        'isAllDay': json['isAllDay'],
        'attendanceType': json['attendanceType'] == null ? undefined : AttendanceTypeFromJSON(json['attendanceType']),
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'clientFirstName': json['clientFirstName'] == null ? undefined : json['clientFirstName'],
        'clientLastName': json['clientLastName'] == null ? undefined : json['clientLastName'],
        'assignedCounselorUserCode': json['assignedCounselorUserCode'] == null ? undefined : json['assignedCounselorUserCode'],
        'location': json['location'] == null ? undefined : json['location'],
        'details': json['details'] == null ? undefined : json['details'],
        'substituteCounselorId': json['substituteCounselorId'] == null ? undefined : json['substituteCounselorId'],
        'substituteCounselorUserCode': json['substituteCounselorUserCode'] == null ? undefined : json['substituteCounselorUserCode'],
        'clientPhone': json['clientPhone'] == null ? undefined : json['clientPhone'],
        'clientEmail': json['clientEmail'] == null ? undefined : json['clientEmail'],
    };
}

export function AppointmentResponseToJSON(json: any): AppointmentResponse {
    return AppointmentResponseToJSONTyped(json, false);
}

export function AppointmentResponseToJSONTyped(value?: AppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': value['appointmentId'],
        'purposeKey': value['purposeKey'],
        'purposeType': PurposeTypeToJSON(value['purposeType']),
        'startTimeUtc': value['startTimeUtc'].toISOString(),
        'endTimeUtc': value['endTimeUtc'].toISOString(),
        'availability': AppointmentAvailabilityToJSON(value['availability']),
        'createdAtUtc': value['createdAtUtc'].toISOString(),
        'isAllDay': value['isAllDay'],
        'attendanceType': AttendanceTypeToJSON(value['attendanceType']),
        'clientId': value['clientId'],
        'clientFirstName': value['clientFirstName'],
        'clientLastName': value['clientLastName'],
        'assignedCounselorUserCode': value['assignedCounselorUserCode'],
        'location': value['location'],
        'details': value['details'],
        'substituteCounselorId': value['substituteCounselorId'],
        'substituteCounselorUserCode': value['substituteCounselorUserCode'],
        'clientPhone': value['clientPhone'],
        'clientEmail': value['clientEmail'],
    };
}

